import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Reveal, SectionTitle } from "./Bits";

const FAQ = [
  { q: "Como funciona o teste grátis de 7 dias?", a: "Você assina Standard ou Pro, informa o cartão e só é cobrado após 7 dias. Cancelou antes? Não paga nada. Dá para cancelar a qualquer momento em Gerenciar assinatura." },
  { q: "Como funciona o WhatsApp?", a: "Nos planos Standard e Pro, você abre a aba WhatsApp no app, envia o código de vinculação uma vez e pronto: mande o que quer orçar por mensagem e receba o PDF na conversa. Para trocar de empresa é só dizer, por exemplo, \"usa a Mega\"." },
  { q: "Posso ter mais de uma empresa ou marca?", a: "Sim. O Standard inclui 3 empresas e o Pro é ilimitado. Cada empresa guarda sua própria logo, cores, fonte e modelo, com orçamentos separados." },
  { q: "A IA entende pedidos informais?", a: "Sim. Descreva o serviço como faria por mensagem — cliente, itens, valores, prazo. A IA extrai tudo, calcula os totais e pergunta apenas o que faltar." },
  { q: "O que muda no PDF entre os planos?", a: "No Free o PDF traz o rodapé \"Feito com Basiq\" e usa 1 modelo com fonte padrão. A partir do Standard o PDF sai sem a marca Basiq, com todos os recursos de personalização (fontes, capa e contracapa) e mais modelos." },
  { q: "Posso mudar de plano depois?", a: "Sim, a qualquer momento em Gerenciar assinatura. A troca é aplicada na hora, com ajuste proporcional na cobrança." },
  { q: "Meus dados estão seguros?", a: "Seus dados ficam vinculados à sua conta e não são compartilhados. Cada usuário só acessa as próprias empresas e orçamentos. O pagamento é processado pela Stripe." },
];

export default function FaqBlock() {
  return (
    <section className="mt-24" data-testid="upgrade-faq">
      <Reveal><SectionTitle eyebrow="Dúvidas frequentes" title="Tudo o que você precisa saber antes de assinar." /></Reveal>
      <Reveal delay={0.05}>
        <Accordion type="single" collapsible className="mt-8 rounded-3xl bg-white ring-1 ring-slate-200 px-6">
          {FAQ.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-slate-100 last:border-b-0">
              <AccordionTrigger data-testid={`upgrade-faq-${i}`} className="text-[15px] font-medium text-slate-900 hover:no-underline py-5">{f.q}</AccordionTrigger>
              <AccordionContent className="text-[14px] text-slate-500 leading-relaxed pb-5">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </section>
  );
}
